<template>
  <div class="checked-modal">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="716px" :append-to-body="true">
      <div class="modal-body">
        <div class="select-filter">
          <el-input @change="changeKey" style="width: 160px" placeholder="请输入查询" suffix-icon="el-icon-search" v-model="searchStr">
          </el-input>
        </div>
        <div class="table-wrap">
          <el-table
            :data="filterData"
            style="width: 100%"
            height="380px"
            @select="handleSelectionChange"
            ref="checkedModalRef"
            :row-key="rowKey"
          >
            <el-table-column type="selection" :reserve-selection="true" width="55"> </el-table-column>
            <el-table-column v-for="item of tableConf" :key="item.colName" :prop="item.colName" :label="item.title"> </el-table-column>
          </el-table>
        </div>
        <span slot="footer" class="footer-wrap">
          <self-pagination
            :total="pageData.total"
            :pageSize="pageData.size"
            :currentPage="pageData.page"
            @getCurrentPage="changePage"
            @handleSizeChange="changePageSize"
          ></self-pagination>
          <div class="bottom-wrap">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="confirmSelect">确 定</el-button>
          </div>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "CheckModal",
  props: {
    title: {
      type: String,
      default: "标题",
    },
    tableConf: {
      type: Array,
      default: () => [],
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    rowKey: {
      type: String,
      default: "name",
    },
    apiName: {
      type: Function,
      default: undefined,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dialogVisible: false,
      searchStr: "",
      pageData: {
        total: 0,
        page: 1,
        size: 10,
      },
      multipleSelection: [],
      apiData: [],
    };
  },
  methods: {
    showModal() {
      this.getData();
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.checkedModalRef.clearSelection();
      });
    },
    changePage(page) {
      this.pageData.page = page;
      this.getData();
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.getData();
    },
    handleSelectionChange(selection, row) {
      if (this.multiple) {
        this.multipleSelection = selection;
      } else {
        this.multipleSelection = [row];
        this.$refs.checkedModalRef.clearSelection();
        this.$refs.checkedModalRef.toggleRowSelection(row, true);
      }
    },
    confirmSelect() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          message: "请至少选择一条数据",
          type: "warning",
        });
      } else {
        if (this.multiple && this.multipleSelection.length > 1) {
          this.$message({
            message: "请选择一条数据",
            type: "warning",
          });
        } else {
          this.dialogVisible = false;
          this.$emit("selectOk", this.multipleSelection);
        }
      }
    },
    changeKey() {
      this.pageData.page = 1;
      this.getData();
    },
    getData() {
      if (this.apiName) {
        this.apiName({
          name: this.searchStr,
          platType: 1,
          page: this.pageData.page,
          size: this.pageData.size,
        }).then((res) => {
          if (res.code === "0000") {
            this.pageData.total = res.count;
            if (this.title === "选择预算包") {
              this.apiData = res.budgetPrices.map((item) => {
                Object.assign(item, JSON.parse(item.data), {
                  date: item.createDate,
                });
                return item;
              });
            } else {
              this.apiData = res.creativeTitles;
            }
          }
        });
      }
    },
  },
  computed: {
    filterData() {
      if (this.apiName) {
        return this.apiData;
      } else {
        return this.tableData.filter((item, index) => {
          if (this.pageData.size * (this.pageData.page - 1) <= index && index < this.pageData.size * this.pageData.page) {
            return true;
          }
        });
      }
    },
  },
  watch: {
    tableData(val) {
      if (this.apiName) {
        this.pageData.total = val.length;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.modal-body {
  .select-filter {
    margin-bottom: 14px;
  }
  .footer-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 0px 24px 0px;
    .bottom-wrap {
      display: flex;
    }
    /deep/ .pagination-wrap {
      padding: 0px;
      text-align: left;
      position: relative;
      left: -10px;
    }
  }
}
</style>
